<template>
  <div class="login" :style="{ backgroundImage: `url(${bgImage})` }">
    <div class="login-overlay"></div>

    <div class="login-card">
      <div class="login-header">
        <img class="login-logo" :src="logoImg" alt="朗视云">
        <h1 class="login-title">杭州朗视云服务平台</h1>
        <p class="login-subtitle">Enterprise Cloud Service Platform</p>
      </div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            size="large"
            clearable
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="login-btn"
            size="large"
            @click="handleLogin"
          >
            <span class="login-btn-text">{{ loading ? '登录中...' : '登 录' }}</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="login-footer">
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >浙ICP备16035809号[浙ICP备16035809号]</a>
    </div>
  </div>
</template>

<script>
import bgImage from '@/assets/images/bg6.jpg'
import logoImg from '@/assets/images/logo.png'

export default {
  name: 'Login',
  data() {
    return {
      bgImage,
      logoImg,
      loading: false,
      showPassword: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码不少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.$message({
            message: '登录成功',
            type: 'success',
            duration: 1500
          })
        }, 1200)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0.15) 50%,
    rgba(0, 0, 0, 0.4) 100%
  );
}

.login-card {
  position: relative;
  z-index: 1;
  width: 420px;
  padding: 48px 40px 36px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.2);
}

.login-header {
  text-align: center;
  margin-bottom: 36px;

  .login-subtitle {
    margin-top: 10px;
  }
}

.login-logo {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.login-title {
  display: inline-block;
  vertical-align: middle;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 0 10px;
  letter-spacing: 1px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.login-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
	letter-spacing: 1px;
}

.login-form {
  .el-input {
    :deep(.el-input__inner) {
      height: 46px;
      font-size: 14px;
      color: #fff;
      background: rgba(244, 246, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.35);
      border-radius: 10px;
      padding-left: 40px;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      &::placeholder {
        color: rgba(255, 255, 255, 0.9);
        font-size: 13px;
				letter-spacing: 1px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(255, 255, 255, 0.55);
      }

      &:focus {
        background: rgba(255, 255, 255, 0.05);
        border-color: #1f3eeb;
        // box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.12);
      }
    }

    :deep(.el-input__prefix) {
      left: 10px;
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			margin-top: 2px;

      .el-input__icon {
        font-size: 17px;
        color: rgba(255, 255, 255, 0.45);
        transition: color 0.3s ease;
      }
    }

    :deep(.el-input__suffix) {
      .el-input__icon {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.35);
        transition: color 0.3s ease;

        &:hover {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }

    &.is-focus {
      :deep(.el-input__prefix) {
        transform: translateX(-2px);
        .el-input__icon {
          color: #409EFF;
        }
      }
    }
  }

  .el-form-item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.login-btn {
  position: relative;
  width: 100%;
  height: 46px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 6px;
  border-radius: 10px;
  color: #fff;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #5a6fe0 0%, #6a3f9a 100%);
    transition: left 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.15) 0%,
      transparent 60%
    );
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;
  }

  .login-btn-text {
    position: relative;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow:
      0 8px 25px rgba(102, 126, 234, 0.4),
      0 4px 12px rgba(118, 75, 162, 0.3);

    &::before {
      left: 0;
    }

    &::after {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow:
      0 4px 12px rgba(102, 126, 234, 0.3),
      0 2px 6px rgba(118, 75, 162, 0.2);
  }
}

.login-footer {
  position: fixed;
  bottom: 28px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;

  a {
    color: #fff;
    font-size: 13px;
    text-decoration: none;
    transition: opacity 0.2s;
    letter-spacing: 0.5px;
    opacity: 0.9;

    &:hover {
      opacity: 1;
    }
  }
}
</style>